import * as React from 'react';

import {TwoLine} from 'shells/two-line/two-line';

import {Body} from '../typography/body';

type TwoLineCellData = {
    text: string;
    description?: string | null;
};

type Props = {
    cell: {
        value: TwoLineCellData;
    };
};

export const TableTwoLineCell = ({cell}: Props) => {
    const {text, description} = cell.value;

    return (
        <TwoLine
            topRow={
                <Body size='small' color='dark' isBold={true} truncate={{type: 'inline'}}>
                    {text}
                </Body>
            }
            bottomRow={
                description ? (
                    <Body size='small' color='light' truncate={{type: 'inline'}}>
                        {description}
                    </Body>
                ) : undefined
            }
            shouldCenterSingleLine={true}
        />
    );
};
